import _classCallCheck from "/home/runner/work/integracao-custos/integracao-custos/frontend/app/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js";
import _createClass from "/home/runner/work/integracao-custos/integracao-custos/frontend/app/node_modules/@babel/runtime-corejs2/helpers/createClass.js";
import Notify from 'quasar/src/plugins/Notify.js';;
var NotifyService = /*#__PURE__*/function () {
  function NotifyService() {
    _classCallCheck(this, NotifyService);
  }
  return _createClass(NotifyService, [{
    key: "error",
    value: function error(msg) {
      Notify.create({
        type: 'negative',
        message: msg,
        color: 'red'
      });
    }
  }, {
    key: "warning",
    value: function warning(message) {
      Notify.create({
        type: 'warning',
        message: message,
        color: 'yellow'
      });
    }
  }, {
    key: "success",
    value: function success(message) {
      Notify.create({
        type: 'positive',
        message: message,
        color: 'green'
      });
    }
  }, {
    key: "info",
    value: function info(message) {
      Notify.create({
        message: message,
        color: 'blue'
      });
    }
  }, {
    key: "infoTopSide",
    value: function infoTopSide(message) {
      Notify.create({
        message: message,
        color: 'blue',
        position: 'top-right'
      });
    }
  }]);
}();
export default NotifyService;